// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import SupportAgent20 from './SupportAgent20.tsx';
import SupportAgent24 from './SupportAgent24.tsx';
import SupportAgent40 from './SupportAgent40.tsx';
import SupportAgent48 from './SupportAgent48.tsx';

type SupportAgentProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    SupportAgent20,
    SupportAgent24,
    SupportAgent40,
    SupportAgent48,
};

const SupportAgent: FC<SupportAgentProps> = ({ variation, ...props }) => {
    const variationKey = `SupportAgent${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"SupportAgent" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default SupportAgent;
